import React, { Component } from 'react';
import ReactDOM from 'react-dom';

/**
*   Import Fontawesome Icons
*   For adding new icons -> import { faName } from '@fortawesome/pro-SIZE-svg-icons' 
*   Add to the library.add();
*   ---
*   In the file where you want the icon -> import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
*   Then in render -> <FontAwesomeIcon icon={['abbreviationSize', 'faName']}/>
*   ---
*   When adding icons from same SIZE, please import in same import line
*   ---
*   If the same icon needs to be added from multiple SIZES -> import { faName as abbreviationSizeFaName }
*   ---
*   Abbreviations:
*   far = fontawesome pro regular
*   fas = fontawesome pro solid
*   fab = fontawesome pro brands
*   fal = fontawesome pro light
*   ---
*/
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTimes as farFaTimes, faAngleRight as farFaAngleRight, faAngleLeft as farFaAngleLeft, faAngleDown as farFaAngleDown, faBars as farFaBars, faPlus as farFaPlus, faSquare as farFaSquare, faCalendar as farFaCalendar, faEllipsisH as farFaEllipsisH } from '@fortawesome/pro-regular-svg-icons';
import { faCircleNotch as falFaCircleNotch, faPlusCircle as falFaPlusCircle, faPaperclip as falFaPaperclip, faAngleRight as falFaAngleRight, faCircle as falCircle, faPlus as falFaPlus } from '@fortawesome/pro-light-svg-icons';
import { faTimes as fasFaTimes, faCog as fasFaCog, faClock as fasFaClock, faThumbtack as fasFaThumbtack,faStepForward as fasFaStepForward,faCamera as fasFaCamera, faPen as fasFaPen, faVolumeUp as fasFaVolumeUp, faVolumeSlash as fasFaVolumeSlash, faCheck as fasFaCheck, faUserCircle as fasFaUserCircle, faCheckSquare as fasFaCheckSquare, faEllipsisV as fasFaEllipsisV, faPlay as fasFaPlay, faPause as fasFaPause, faTrash as fasFaTrash, faExclamationCircle as fasExclamationCircle, faCheckCircle as fasCheckCircle, faTimesCircle as fasTimesCircle } from '@fortawesome/pro-solid-svg-icons';

library.add( fasFaCog, fasFaTimes, farFaTimes ,fasFaClock, fasFaThumbtack,fasFaStepForward,fasFaCamera, fasFaPen, farFaAngleLeft, farFaAngleRight, farFaAngleDown, falFaCircleNotch, farFaBars, fasFaVolumeSlash, fasFaVolumeUp, fasFaCheck, fasFaUserCircle, fasFaCheckSquare, farFaPlus, farFaSquare, falFaPlusCircle, fasFaEllipsisV, fasFaPlay, fasFaPause, fasFaTrash, falFaPaperclip, farFaCalendar, farFaEllipsisH, fasExclamationCircle, falFaAngleRight, falCircle, fasCheckCircle, fasTimesCircle, falFaPlus);


import './styles/App.scss';
import App from 'components/App';

ReactDOM.render(<App />, document.getElementById('root'));